import { restPwd } from "@/api/user";
import { iconBukaohe, iconKaohe } from "@/assets/image/icon-set/index.js";
import { Confirm } from "@/components/Confirm";
import List from "@/components/list";
import vue from "@/main";
import router from "@/router";
import store from "@/store";
import { getItem } from "@/utils/storage";
import { Message } from "element-ui";
import "./table.scss";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const toStudyInfo = listeners["study-info"] || function() {};
  const showPermissionDia = listeners["showPermissionDia"] || function() {};
  const examineSetting = listeners["examineSetting"] || function() {};
  const flatPermissions = store.getters.flatPermissions;
  const toChangeInfo = listeners["toChangeInfo"] || function() {};
  const zwyVisitSetting = listeners["zwyVisitSetting"] || function() {};

  const deleteUser = listeners["deleteUser"] || function() {};
  const reviewUser = listeners["reviewUser"] || function() {};
  const unbindZZD = listeners["unbindZZD"] || function() {};
  const tempBeNormal = listeners["tempBeNormal"] || function() {};
  // 重置密码
  async function resetPwd(uuid) {
    const text = "您确认重置密码为初始密码吗";
    try {
      await Confirm(text, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      restPwd({ uuids: [uuid] }).then((res) => {
        if (!res || res.code != 0) return;
        Message({
          message: "重置成功",
          type: "success",
        });
      });
    } catch (error) {
      if (error === "cancel") return;
    }
  }

  function toEdit(user) {
      router.push({
        path: user.isTemp === 1 ? "user/editTemporary" : "/user/edit",
        query: {
          id: user.uuid,
        },
      });
  }

  const permissionList = [
    "user:update",
    "user:resetpwd",
    "user:permission",
    "sysUserMoveRecord:page",
    "user:userAddAudit",
    "user:studyInfo",
    "user:delete",
  ];

  const Deal = ({ props: { vo } }) => {
    const user = vo.row;
    const dealConf = [];
    if (user.userAuditStatusName === "审核中") {
      dealConf.push(["icon-edit-disable", "编辑", () => {}, user.isTemp === 1 ? "user:temp:update" : "user:update"]); 
    } else {
      dealConf.push(["icon-edit", "编辑", () => {toEdit(user)}, user.isTemp === 1 ? "user:temp:update" : "user:update"]);
    }
    if (
      user.userAuditStatusName !== "审核中" &&
      user.userAuditStatusName !== "审核不通过"
    ) {
      dealConf.push([
        "icon-password",
        "重置密码",
        () => resetPwd(user.uuid),
        "user:resetpwd",
      ]);
      if (user.userType !== 0) {
        dealConf.push([
          "icon-permission-disable",
          "权限设置",
          () => {},
          "user:permission",
        ]);
      } else {
        dealConf.push([
          "icon-permission",
          "权限设置",
          () => {
            showPermissionDia(user);
          },
          "user:permission",
        ]);
      }
      dealConf.push([
        "icon-diaodong",
        "调动记录",
        () => {
          router.push({
            path: "/user/sysUserMoveRecord",
            query: { id: user.uuid },
          });
        },
        "sysUserMoveRecord:page",
      ]);
      if (user.userStatus == 0) {
        dealConf.push([
          "iconfont ickaoheshezhi_sel iconfont-adapt",
          "考核设置",
          () => {
            examineSetting(user);
          },
          "user:updateIsExam",
        ]);
      } else {
        dealConf.push([
          "iconfont ickaoheshezhi_sel iconfont-adapt-disabled",
          "考核设置",
          () => {},
          "user:updateIsExam",
        ]);
      }
      
    } else {
      dealConf.push([
        "icon-password-disable",
        "重置密码",
        () => {},
        "user:resetpwd",
      ]);
      dealConf.push([
        "icon-permission-disable",
        "权限设置",
        () => {},
        "user:permission",
      ]);
      dealConf.push([
        "icon-diaodong-disable",
        "调动记录",
        () => {},
        "sysUserMoveRecord:page",
      ]);
      dealConf.push([
        "iconfont ickaoheshezhi_sel iconfont-adapt-disabled",
        "考核设置",
        () => {},
        "user:updateIsExam",
      ]);
    }
    // 只有审核不通过能进行送审---编辑和送审权限，审核中不进行任何操作----只能进行取消送审的操作(不要取消送审了)
    if (user.userAuditStatusName === "审核不通过") {
      dealConf.push([
        "icon_review",
        "送审",
        () => reviewUser(user.uuid),
        "user:userAddAudit",
      ]);
    } else {
      dealConf.push([
        "icon_review-disable",
        "送审",
        () => {},
        "user:userAddAudit",
      ]);
    }
    dealConf.push([
      "icon_user_study",
      "学习信息",
      () => {
        toStudyInfo(user);
      },
      "user:studyInfo",
    ]);
    if (
      getItem("UUID_USER") !== user.uuid &&
      user.userAuditStatusName !== "审核中"
    ) {
      dealConf.push([
        "icon-delete",
        "删除",
        () => deleteUser(user.uuid, user.userName),
        "user:delete",
      ]);
    } else {
      dealConf.push(["icon-delete-disable", "删除", () => {}, "user:delete"]);
    }
    
    // dealConf.push([
    //   "icon-diaodong",
    //   "变更记录",
    //   () => {
    //     toChangeInfo(user);
    //   },
    //   "sysUserMoveRecord:page",
    // ]);
    dealConf.push([
      "iconfont iczhongwangyuanfangwenshezhi_sel iconfont-adapt",
      "中网院访问设置",
      () => {
        zwyVisitSetting(user);
      },
      "user:updateCanVisitZwy:batch",
    ]);
    // 浙政钉绑定状态---
    if (user.bindStatus === 1) {
      dealConf.push([
        "iconfont icjiebangzhezhengding iconfont-adapt",
        "解绑浙政钉",
        () => {
          unbindZZD(user)
        },
        "user:bind",
      ]);
    } else {
      dealConf.push([
        "iconfont icjiebangzhezhengding iconfont-adapt-disabled",
        "解绑浙政钉",
        () => {},
        "user:bind",
      ]);
    }

    if (user.isTemp === 1) {
      dealConf.push([
        "iconfont iczhuanweizhengshiyonghu iconfont-adapt",
        "转为正式用户",
        () => {
          tempBeNormal(user)
        },
        "user:temp:normal",
      ]);
    }
    
    // icjiebangzhezhengding

    return (
      <div class="deal-group">
        {dealConf.map((item) => {
          const hasAdjustRecord = item[1] == '调动记录' && user.hasAdjustRecord
          return (
            <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
              <i class={item[0]} onClick={item[2]}>
              {
                 hasAdjustRecord ? (<div class="red-badge"></div>) : null
              }
              </i>
            </el-tooltip>
          )
        })}
      </div>
    );
  };

  function toDetail(item) {
    if (item.isTemp === 1) {
      router.push({
        path: "/user/detailTemporary",
        query: { id: item.uuid },
      });
    } else {
      router.push({
        path: "/user/detail",
        query: { id: item.uuid, status: true },
      });
    }
  }

  const NameColumn = ({ props: { vo } }) => {
    const item = vo.row;
    let flag = item.isExamName === "是";
    return (
      <div>
        <div>
          <span
            class="blue_char"
            onClick={() => {
              toDetail(item)
            }}
          >
            {item.userName}
          </span>
          <img class="audit_img" src={flag ? iconKaohe : iconBukaohe} alt="" />
        </div>
        <div class="coll_char">
          {item.topDeptName}/{item.leaderTypeName}
        </div>
        <div class="coll_char">
          {item.cadreLevelName}
        </div>
      </div>
    );
  };

  const AccountColum = ({ props: { vo } }) => {
    const item = vo.row;
    let flag =
      item.accountStatusName === "启用" &&
      item.userAuditStatusName === "审核通过";
    return (
      <div class="user_status">
        <div>
          <div class={flag ? "green_dot" : "yellow_dot"}></div>
        </div>
        <div>
          <div>{item.accountStatusName}</div>
          <div class="audit_char">{item.userAuditStatusName}</div>
        </div>
      </div>
    );
  };

  const UserStatus = ({props: {vo}}) => {
    const item = vo.row;
    return (
      <div class='user-status'>
        {item.userStatusName}
        <div class={item.canVisitZwy ? 'green_tag' : 'gray_tag'}>中网院</div>
      </div>
    )
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      width: "32",
    },
    {
      label: "姓名",
      width: "170",
      render: (vo) => <NameColumn vo={vo} />,
    },
    {
      label: "单位",
      prop: "deptName",
      minWidth: "120",
    },
    // {
    //   label: "职级",
    //   prop: "positionLevelName",
    //   width: "90",
    // },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "220",
    },
    {
      label: "用户状态",
      prop: "userStatusName",
      width: "80",
      showOverflowTooltip: true,
      render: (vo) => <UserStatus vo={vo} />,
    },
    {
      label: "账号状态",
      prop: "accountStatusName",
      width: "100",
      render: (vo) => <AccountColum vo={vo} />,
    },
  ];

  let iconNum = 0;
  permissionList.forEach((x) => {
    if (flatPermissions.includes(x)) {
      iconNum += 1;
    }
  });
  if (iconNum > 0) {
    AccountTableConfig.push({
      label: "操作",
      fixed: "right",
      width: String(iconNum * 30 + 10 > 130 ? 130 : iconNum * 30 + 10),
      render: (vo) => <Deal vo={vo} />,
    });
  }

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
